<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-06 18:28:13
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-01-19 17:48:06
-->
<template>
	<div>
		<el-dialog :title="title" :visible.sync="dialogVisible" width="600px" :before-close="handleClose">
			<div slot="title">
				<span>{{ title }}</span>
				<span class="font-h4-regular yx-color-primary ml-12 cursor-pointer" @click="seeTaskList">查看任务列表</span>
			</div>
			<Tip class="mb-20 mt-4" ref="tips">{{ tipText }}</Tip>

			<el-form class="mt-16" :model="form" :rules="rules" ref="ruleForm" label-width="140px">
				<el-form-item style="width: 310px" label="同步内容" prop="activityProductStatus">
					<el-radio-group style="display: flex" v-model="checked" @change="clearForm()">
						<el-radio style="margin-right: 2px" border :label="0">同步指定商品</el-radio>
						<el-radio style="margin-right: 2px" border :label="1" v-if="$isPlatOr(platformId, ['Dy', 'Ks'])">同步指定活动</el-radio>
						<el-radio style="margin-right: 2px" border :label="2">全量同步商品</el-radio>
					</el-radio-group>
				</el-form-item>
				<template v-if="!isAllSync">
					<el-form-item v-if="isActivitySync" label="商品状态" prop="activityProductStatus">
						<el-select style="width: 255px" v-model="activityProductStatus" placeholder="请选择" @change="onChangeSelect">
							<el-option v-for="item in activityProductStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item v-if="isActivitySync" label="商品同步范围" prop="activitySyncMode">
						<el-radio style="margin-right: 2px" border @input="activitySyncModeInput" v-model="activitySyncMode" label="2">
							新增商品
							<el-tooltip class="item" effect="dark" placement="top" content="同步新报活动商品">
								<el-icon class="el-icon-question question-icon"></el-icon>
							</el-tooltip>
						</el-radio>
						<el-radio border @input="activitySyncModeInput" v-model="activitySyncMode" label="1">
							全部商品
							<el-tooltip class="item" effect="dark" placement="top" content="同步新报活动商品同时更新商品信息">
								<el-icon class="el-icon-question question-icon"></el-icon>
							</el-tooltip>
						</el-radio>
					</el-form-item>
					<el-form-item style="width: 310px" label="机构名称" prop="authority_id">
						<commander-select
							style="width: 255px"
							:platformId="platformId"
							v-model="form['authority_id']"
							:show-all="true"
							@change="commanderChange"
						></commander-select>
					</el-form-item>
					<el-form-item label="店铺名称" prop="third_shop_id" v-if="isShowThirdShopId">
						<el-select
							style="width: 255px"
							v-model="form.third_shop_id"
							filterable
							reserve-keyword
							placeholder="请选择店铺"
							:loading="thirdShopPage.thirdShopLoading"
							@change="thirdShopChangeEvent"
						>
							<el-option
								v-for="item in thirdShopPage.thirdShopOption"
								:key="item.thirdShopId"
								:label="item.thirdShopName"
								:value="item.thirdShopId"
							></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="活动ID" prop="item_id" v-if="isShowActivity">
						<el-select
							v-scroll-lazy-load="{
								loadData: activityLoadData,
								distance: 50,
								delay: 300,
								scrollBody: '.el-scrollbar__wrap',
								callback: fn => this.$once('hook:beforeDestroy', () => fn()),
							}"
							:key="form.authority_id"
							allow-create
							style="width: 255px"
							v-model="formItem_id"
							default-first-option
							filterable
							clearable
							remote
							reserve-keyword
							placeholder="请输入活动ID或活动名称"
							@change="handleSelectActivity"
							:remote-method="activityRemoteMethod"
							:loading="activityPage.activityLoading"
							@visible-change="onVisibleChange"
						>
							<el-option
								v-for="item in activityPage.activityOptions"
								:key="item.activity_id"
								:label="`${item.activity_name}(${item.third_activity_id})`"
								:value="item.activity_id"
							></el-option>
						</el-select>
					</el-form-item>
					<div style="margin-left: 100px" class="mb-18" v-if="isShowActivity">
						<div class="fz-12">
							未同步过的活动，仅支持输入完整的活动ID。
							<span class="yx-color-primary" @click="goToUrl">如何获取活动ID？</span>
						</div>
						<div class="fz-12">已同步过活动列表的活动。可输入活动名称或ID进行搜索</div>
					</div>
					<el-form-item v-if="isShopSync" label="商品ID/名称" prop="item_id1">
						<el-select
							v-scroll-lazy-load="{
								loadData: goodLoadData,
								distance: 50,
								delay: 300,
								scrollBody: '.el-scrollbar__wrap',
								callback: fn => this.$once('hook:beforeDestroy', () => fn()),
							}"
							allow-create
							style="width: 255px"
							v-model="form.item_id1"
							filterable
							remote
							reserve-keyword
							placeholder="请输入商品ID或商品名称"
							:remote-method="goodRemoteMethod"
							:loading="productPage.goodLoading"
						>
							<el-option
								v-for="item in productPage.goodOptions"
								:key="item.third_product_id"
								:label="item.product_name"
								:value="item.third_product_id"
							></el-option>
						</el-select>
					</el-form-item>
				</template>

				<!-- <div class="mt-8 desc fz-12">指定商品信息，同步更快</div> -->
			</el-form>
			<template v-if="isAllSync">
				<div class="mt-16">
					<div class="flex flex-align-center">
						<div class="mr-10 text-align-right fz-14 color-gy-9" style="width: 128px">商品状态</div>
						<el-select :disabled="$isSp()" v-model="productStatus" placeholder="请选择" style="width: 255px">
							<el-option v-for="item in productStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
						</el-select>
					</div>
				</div>
				<synchronization-list :platformId="platformId" @change="synchronCallback"></synchronization-list>
			</template>
			<span slot="footer">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="submit" :loading="loading">确认同步</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import debounce from 'lodash/debounce';
import { syncProductList, syncActivityList, pullBusinessGoods, apiSpShopList, syncProductListSp } from '@/api/shopManage';
import synchronizationList from './synchronizationList.vue';
import commanderSelect from '@/components/commanderSelect/index.vue';
import dataMap from '../../../utils/dataMap';
export default {
	name: 'chooseAsyncTaskDialog',
	props: {
		title: {
			type: String,
			default: '同步团长商品',
		},
		sync_info: {
			type: Object,
			default: () => {
				return null;
			},
		},
	},
	components: {
		synchronizationList,
		commanderSelect,
	},
	data() {
		return {
			dialogVisible: false,
			checked: 0,
			formItem_id: '', //活动id
			form: {
				item_id: '',
				item_id1: '',
				authority_id: '',
				third_shop_id: '', //店铺
			},
			rules: {
				item_id: { required: true, message: '请输入活动ID', trigger: 'blur' },
				item_id1: { required: true, message: '请输入商品ID或商品名称', trigger: 'blur' },
				authority_id: { required: true, message: '请选择机构ID', trigger: 'bur' },
				third_shop_id: { required: true, message: '请选择店铺', trigger: 'bur' },
			},
			productStatusOptions: [
				{ label: '全部', value: null },
				{ label: '待审核', value: 0 },
				{ label: '推广中', value: 1 },
				{ label: '合作已终止', value: 3 },
				{ label: '合作已到期', value: 6 },
			],

			platformId: '',
			loading: false,

			productPage: {
				goodLoading: false,
				goodOptions: [],
				page_index: 1,
				page_size: 20,
				page_has: true,
				query: '',
			},
			activityPage: {
				activityLoading: false,
				activityOptions: [],
				page_index: 1,
				page_size: 20,
				page_has: true,
				query: '',
			},
			//店铺名称
			thirdShopPage: {
				thirdShopLoading: false,
				thirdShopOption: [],
			},
			institution_id: '',
			productStatus: 1,
			activityProductStatus: null,
			activitySyncMode: '2',
		};
	},
	computed: {
		isShopSync() {
			return this.checked === 0;
		},
		isActivitySync() {
			return this.checked === 1;
		},
		isAllSync() {
			return this.checked === 2;
		},
		activityProductStatusOptions({ activitySyncMode }) {
			let arr = [
				{ label: '全部', value: null },
				{ label: '待审核', value: 0 },
				{ label: '推广中', value: 1 },
				{ label: '合作已终止', value: 3 },
				{ label: '合作已到期', value: 6 },
			];
			return +activitySyncMode === 2 ? arr.filter(val => val.label === '全部') : arr;
		},
		tipText() {
			const temPF = {
				[+dataMap.PLATFORM_DY.value]: '[指定活动/全量商品]同步商品任务会因商品越多同步越慢，请耐心等待。',
				[+dataMap.PLATFORM_SP.value]: '[全量商品]同步商品任务会因商品越多同步越慢，请耐心等待。',
			};
			return temPF[+this.platformId];
		},
		isShowActivity() {
			//活动部分展示：form.authority_id已选并且不为视频号
			return this.$isPlatOr(this.platformId, ['Dy', 'Ks']) && this.form.authority_id;
		},
		isShowThirdShopId() {
			//店铺名称展示：form.authority_id已选并且为视频号
			return this.$isSp(this.platformId) && this.form.authority_id;
		},
	},
	created() {},
	methods: {
		activitySyncModeInput(val) {
			if (val == 2) {
				this.activityProductStatus = null;
			}
		},
		show(platformId) {
			this.platformId = platformId;
			this.dialogVisible = true;
		},
		commanderChange(obj) {
			this.activityPage.activityOptions = [];
			this.activityPage.query = '';
			this.form.third_shop_id = '';
			this.thirdShopPage.thirdShopOption = [];
			this.synchronCallbackChange(obj);
			const temPF = {
				[+dataMap.PLATFORM_DY.value]: this.getActivityList,
				[+dataMap.PLATFORM_SP.value]: this.getShopList,
			};
			temPF[+this.platformId]();
		},
		//视频号根据团长下的店铺
		async getShopList() {
			this.thirdShopPage.thirdShopLoading = true;
			try {
				const res = await apiSpShopList({
					authorityId: this.form.authority_id,
				});
				this.thirdShopPage.thirdShopOption.push(...res.data);
			} finally {
				this.thirdShopPage.thirdShopLoading = false;
			}
		},
		handleClose() {
			this.dialogVisible = false;
			this.checked = 0;
			(this.activityProductStatus = null), (this.activitySyncMode = '2');
			this.form = {
				item_id: '',
				item_id1: '',
				authority_id: '',
				third_shop_id: '', //店铺
			};
			this.formItem_id = '';
			this.productPage = {
				goodLoading: false,
				goodOptions: [],
				page_index: 1,
				page_size: 20,
				page_has: true,
				query: '',
			};
			this.activityPage = {
				activityLoading: false,
				activityOptions: [],
				page_index: 1,
				page_size: 20,
				page_has: true,
				query: '',
			};
			this.$refs.ruleForm.resetFields();
		},
		clearForm() {
			this.institution_id = '';
			this.form = {
				item_id: '',
				item_id1: '',
				authority_id: '',
				third_shop_id: '', //店铺
			};
			this.formItem_id = '';
			this.productPage = {
				goodLoading: false,
				goodOptions: [],
				page_index: 1,
				page_size: 20,
				page_has: true,
				query: '',
			};
			this.activityPage = {
				activityLoading: false,
				activityOptions: [],
				page_index: 1,
				page_size: 20,
				page_has: true,
				query: '',
			};
			this.$refs.ruleForm.resetFields();
			if (this.$isSp() && this.isAllSync) {
				// 视频号 并且 是全量同步商品
				this.productStatus = this.productStatusOptions[0].value;
			}
		},
		submit: debounce(function () {
			const { isAllSync } = this;
			if (isAllSync) return this.form.authority_id ? this.pullBusinessGoods() : this.$message.error('请选择团长进行同步');
			this.$refs.ruleForm.validate(valid => {
				if (!valid) return;
				this.pullBusinessGoods();
			});
		}, 500),
		//抖音同步
		async pullBusinessGoods() {
			const { institution_id, isShopSync, isActivitySync, productStatus, activityProductStatus, activitySyncMode, checked } = this;
			try {
				this.loading = true;
				const checkedMap = {
					0: 1,
					1: 2,
					2: 4,
				};
				let instSyncInfo = {
					syncType: checkedMap[checked],
				};
				let syncMode = '1';
				if (isShopSync) {
					instSyncInfo.productId = this.form.item_id1;
					instSyncInfo.activityId = this.form.item_id;
					instSyncInfo.instId = institution_id;
				} else if (isActivitySync) {
					instSyncInfo.activityId = this.form.item_id;
					instSyncInfo.instId = institution_id;
					instSyncInfo.productStatus = activityProductStatus;
					syncMode = activitySyncMode;
					if (activitySyncMode == 1) {
						// syncType 同步指定商品1 同步指定活动-新增商品2 同步指定活动-全部商品3  全量同步商品4
						instSyncInfo.syncType = 3;
					}
				} else {
					instSyncInfo.instId = institution_id;
					instSyncInfo.productStatus = productStatus;
				}
				if (checked == 2) {
					// 全量同步下 固定值为2
					syncMode = 2;
				}
				const temPF = {
					[dataMap.PLATFORM_DY.value]: '12',
					[dataMap.PLATFORM_SP.value]: '31',
				};
				let params = {
					tripartiteType: temPF[this.platformId], //同步类型
					syncMode: syncMode, //同步模式
					syncSource: '1',
					instSyncInfo: instSyncInfo,
				};
				if (this.$isSp(this.platformId)) {
					params.applicationId = 1; // 超佣团1 超盘手2
					params.instSyncInfo.thirdShopId = this.form.third_shop_id; //指定视频号小店appid  todo
				}

				const data = await pullBusinessGoods(params);
				this.loading = false;
				this.$emit('startAsyncTask', data.taskId);
				this.handleClose();
			} catch (e) {
				this.loading = false;
			}
		},
		goToUrl() {
			window.open('https://yangxuan.feishu.cn/docs/doccnLUXeHaN529JVHDZB0Ky80r');
		},
		onVisibleChange() {
			if (!this.formItem_id) {
				this.activityPage.query = '';
				this.activityPage.activityOptions = [];
				this.getActivityList();
			}
		},
		activityRemoteMethod: debounce(function (query) {
			this.activityPage.query = query;
			this.activityPage.page_index = 1;
			this.activityPage.activityOptions = [];
			this.getActivityList();
		}, 300),
		async getActivityList() {
			this.activityPage.page_index == 1 && (this.activityPage.activityLoading = true);
			try {
				const res = await syncActivityList({
					platform_id: this.platformId,
					page_index: this.activityPage.page_index,
					page_size: this.activityPage.page_size,
					q: this.activityPage.query,
					authority_id: this.form.authority_id,
					req_source_type: 1,
				});
				this.activityPage.activityOptions.push(...res.data.list);
				this.activityPage.page_index = res.data.page.page_index;
				this.activityPage.page_has = res.data.page.page_has;
			} finally {
				this.activityPage.activityLoading = false;
			}
		},
		synchronCallback(obj) {
			const { tripartiteInstId, instId } = obj;
			this.form.authority_id = tripartiteInstId;
			this.institution_id = instId;
			this.formItem_id = '';
			this.form.item_id = '';
			this.form.third_shop_id = '';
		},
		synchronCallbackChange(obj) {
			const { authority_id, id: institution_id } = obj;
			this.form.authority_id = authority_id;
			this.institution_id = institution_id;
			this.formItem_id = '';
			this.form.item_id = '';
			this.form.third_shop_id = '';
		},

		goodRemoteMethod: debounce(function (query) {
			this.productPage.query = query;
			this.productPage.page_index = 1;
			this.productPage.goodOptions = [];
			this.getProductLis();
		}, 300),

		async getProductLis() {
			if (this.$isDy(this.platformId)) {
				if (!isNaN(this.formItem_id)) {
					this.productPage.page_index == 1 && (this.productPage.goodLoading = true);
					try {
						const res = await syncProductList({
							activity_id: this.formItem_id,
							page_index: this.productPage.page_index,
							page_size: this.productPage.page_size,
							product_search: this.productPage.query,
							audit_status: '-1',
							platform_id: this.platformId,
						});
						this.productPage.goodOptions.push(...res.data.list);
						this.productPage.page_index = res.data.page.page_index;
						this.productPage.page_has = res.data.page.page_has;
					} catch (e) {}
					this.productPage.goodLoading = false;
				}
			} else if (this.$isSp(this.platformId)) {
				if (this.form.third_shop_id) {
					this.productPage.page_index == 1 && (this.productPage.goodLoading = true);
					try {
						const res = await syncProductListSp({
							authorityId: this.form.authority_id,
							shopId: this.form.third_shop_id, //店铺
							product_search: this.productPage.query,
							page_index: this.productPage.page_index,
							page_size: this.productPage.page_size,
						});
						this.productPage.goodOptions.push(...res.data.list);
						this.productPage.page_index = res.data.page.page_index;
						this.productPage.page_has = res.data.page.page_has;
					} catch (e) {}
					this.productPage.goodLoading = false;
				}
			}
		},

		activityLoadData() {
			if (this.activityPage.page_has && !this.activityPage.goodLoading) {
				this.activityPage.page_index = this.activityPage.page_index + 1;
				this.getActivityList();
			}
		},
		goodLoadData() {
			if (this.productPage.page_has && !this.productPage.goodLoading) {
				this.productPage.page_index = this.productPage.page_index + 1;
				this.getProductLis();
			}
		},
		handleSelectActivity() {
			const val = this.activityPage.activityOptions.find(item => {
				return item.activity_id == this.formItem_id;
			});
			this.form.item_id = val?.third_activity_id || this.formItem_id;
			this.form.item_id1 = '';
			this.goodRemoteMethod();
		},
		//店铺change
		thirdShopChangeEvent() {
			this.form.item_id1 = ''; //商品清空
			this.goodRemoteMethod();
		},

		seeTaskList() {
			this.$emit('seeTaskList');
		},
		onChangeSelect(val) {
			if (val === null) {
				this.activitySyncMode = '2';
			}
		},
	},
};
</script>

<style lang="less" scoped>
.el-input {
	width: 212px;
}
.desc {
	margin-left: 100px;
}
.question-icon {
	margin-left: 5px;
	color: #c8c9cc;
}
</style>
